import { getAddressDisplay } from 'lib/helpers/address';

import { dateOnly } from './invoiceDocModel';

export const buildParty = ({ patient, hidden, timezone }) => {
  const show = (key) => !hidden.has(key);

  const identity = [
    show('pt_id') && patient?.id ? `#${patient.id}` : '',
    show('pt_dob') && patient?.dob ? `DOB ${dateOnly(patient.dob, timezone)}` : '',
    show('pt_gender') ? patient?.gender || '' : ''
  ]
    .filter(Boolean)
    .join(' · ');

  const address =
    getAddressDisplay(patient?.userAddress) ||
    (patient?.address && typeof patient.address === 'object'
      ? [patient.address.address, patient.address.city, patient.address.state, patient.address.zip]
          .filter(Boolean)
          .join(', ')
      : patient?.address || '');

  const name = patient?.fullName || [patient?.f_name, patient?.l_name].filter(Boolean).join(' ');

  return {
    label: 'Billed to',
    name: show('pt_name') ? name : '',
    lines: [
      identity,
      show('pt_address') ? address : '',
      [show('pt_phone') ? patient?.phone : '', show('pt_email') ? patient?.email : '']
        .filter(Boolean)
        .join(' · ')
    ].filter(Boolean)
  };
};

export const buildDocLines = ({ number, issuedDate, dueDate, dueAmount }) => {
  const lines = [];

  const issued = [];
  if (number) issued.push({ label: 'Invoice ', value: number });
  if (issuedDate) issued.push({ label: 'Issued ', value: issuedDate });
  if (issued.length) lines.push(issued);

  const due = [];
  if (dueDate) due.push({ label: 'Due ', value: dueDate });
  if (dueAmount) due.push({ label: dueDate ? '' : 'Amount due ', value: dueAmount });
  if (due.length) lines.push(due);

  return lines;
};
